import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { accountKeys } from '@/lib/queries/account';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { ConsentHistory } from './-components/ConsentHistory';
import { PrivacyClient } from './-components/PrivacyClient';

export const Route = createFileRoute('/_authed/settings/privacy/')({
  component: SettingsPrivacyPage,
});

function SettingsPrivacyPage() {
  const privacyQuery = useQuery({
    ...identityKeys.privacy(),
    retry: false,
  });
  const blocksQuery = useQuery(accountKeys.blockedMembers({ pageSize: 50 }));
  // Prefetch consent history so the ConsentHistory child renders fast.
  useQuery(identityKeys.consentHistory());

  if (privacyQuery.isError) {
    return (
      <SettingsErrorShell
        title="Privacy and visibility"
        message="Could not load privacy settings."
      />
    );
  }
  if (privacyQuery.isLoading || !privacyQuery.data) return null;
  const data = privacyQuery.data;
  const blockedCount = blocksQuery.data?.items.length ?? 0;

  return (
    <PrivacyClient
      marketingOptIn={data.marketingOptIn}
      directoryVisibleOptIn={data.directoryVisibleOptIn}
      showCirclesOnProfile={data.showCirclesOnProfile}
      showActivityFeed={data.showActivityFeed}
      allowSearchEngineIndex={data.allowSearchEngineIndex}
      profileVisibilityScope={data.profileVisibilityScope}
      blockedCount={blockedCount}
      historySlot={<ConsentHistory />}
    />
  );
}
